// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-ManageBlackBox-Users-styles___bodyPaper--B2QLQ {
  width: 100%;
}

.components-ManageBlackBox-Users-styles___notFound--QaKcE {
  text-align: center;
  margin: 20px;
  font-size: 18px;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
}

.components-ManageBlackBox-Users-styles___bbusersTable--Kd_fZ tr:last-child td {
    border-bottom: none !important;
  }
`, "",{"version":3,"sources":["webpack://./components/ManageBlackBox/Users/styles.pcss"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uDAAuD;AACzD;;AAGE;IACE,8BAA8B;EAChC","sourcesContent":[".bodyPaper {\n  width: 100%;\n}\n\n.notFound {\n  text-align: center;\n  margin: 20px;\n  font-size: 18px;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n}\n\n.bbusersTable {\n  tr:last-child td {\n    border-bottom: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyPaper": `components-ManageBlackBox-Users-styles___bodyPaper--B2QLQ`,
	"notFound": `components-ManageBlackBox-Users-styles___notFound--QaKcE`,
	"bbusersTable": `components-ManageBlackBox-Users-styles___bbusersTable--Kd_fZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
